export default "__VITE_ASSET__BWUTV$Es__"